<template>
    <vx-card no-shadow>
        <vue-headful :title="$t('change_password')" />
        <!-- Инпуты ввода праолей -->
        <vs-input
            class="w-full mb-base"
            :label-placeholder="$t('old_password')"
            v-model="old_password"
        />
        <vs-input
            class="w-full mb-base"
            :label-placeholder="$t('new_password')"
            v-model="new_password"
        />
        <vs-input
            class="w-full mb-base"
            :label-placeholder="$t('comfirm_password')"
            v-model="confirm_new_password"
        />

        <!-- Save & Reset Button -->
        <div class="flex flex-wrap items-center justify-end">
            <vs-button class="ml-auto mt-2" @click="sendNewPassword">{{
                $t("save")
            }}</vs-button>

            <vs-button
                class="ml-4 mt-2"
                type="border"
                color="warning"
                @click="reset"
                >{{ $t("reset") }}</vs-button
            >
        </div>
    </vx-card>
</template>

<script>
export default {
    data() {
        return {
            old_password: "",
            new_password: "",
            confirm_new_password: "",
        };
    },
    computed: {
        activeUserInfo() {
            return this.$store.state.AppActiveUser;
        },
    },
    methods: {
        reset() {
            // Очищяю переменные
            this.old_password = "";
            this.new_password = "";
            this.confirm_new_password = "";
        },
        async sendNewPassword() {
            try {
                // Включаю лоадер
                this.$vs.loading();

                // Пинаю запрос
                const response = await this.$http.post(
                    "user/change/password/",
                    {
                        oldPassword: this.old_password,
                        passwordConfirm: this.confirm_new_password,
                        password: this.new_password,
                    }
                )

                if (response.data.message === 1) {
                    // Вывожу уведомление
                    this.$vs.notify({
                        color: "success",
                        title: this.$t("succesful"),
                        text: this.$t("success_save_password"),
                    });

                    this.reset();
                }
            } catch (e) {
                // Определяю ключ i18n({ response: keyI18N })
                const notifications = {
                    2: "passwords_do_not_match",
                    3: "invalid_current_password",
                };
                // Вывожу уведомления
                this.$vs.notify({
                    color: "warning",
                    title: this.$t("error"),
                    text: this.$t(notifications[e.message]),
                });
            } finally {
                // Отключаю лоадер
                this.$vs.loading.close();
            }
        },
    },
};
</script>
